import React, { useContext, useEffect } from 'react';

import { ConfigProvider, Layout, Button, Select } from 'antd';
import { AndroidFilled, AppleFilled } from '@ant-design/icons';

import { Context } from '../context';
import { translations } from '../helpers/i18n';
import LanguageSelector from './LanguageSelector';

const { Header, Content } = Layout;

function AppLayout({children, pageTitle}) {

  const {
    appButtonContentColor,
    appLogoHorizontal,
    appSecondaryColor,
    appPrimaryColor,
    topBarTextColor,
    appButtonColor,  
    linkAndroid,  
    deviceType,
    linkIos,
    baseUrl,
    language,
  } = useContext(Context);

  const t = translations[language] || translations.IT;

  useEffect(()=>{
    
      //applico delle modifiche ai colori
      document.querySelector(':root').style.setProperty('--buttonContentColor', appButtonContentColor);
      document.querySelector(':root').style.setProperty('--secondary', appSecondaryColor);
      document.querySelector(':root').style.setProperty('--buttonColor', appButtonColor);
      document.querySelector(':root').style.setProperty('--primary', appPrimaryColor);
      document.querySelector(':root').style.setProperty('--topBarTextColor', topBarTextColor);

  },[appPrimaryColor])

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary:appPrimaryColor,
        },
      }}
    >
        <Layout className="layout">
          <Header
            style={{
              display: 'flex',
              alignItems: 'center',
              background:appPrimaryColor
            }}
            className='p-0'
          >
            <div className="logo h-100 p-10 w-100">
              <img src={baseUrl + appLogoHorizontal} className='h-100'/>
            </div>
            <div className='page-title'>
            {pageTitle}
            </div>
            <LanguageSelector/>
          </Header>
          <Content>
          {children}
          </Content>
          <a href={deviceType !== "iPhone" && deviceType !== "iPad" && deviceType !== "Macintosh" ? linkAndroid : linkIos} target='_blank'>
            <Button
              type='primary'
              size='large'
              className='float-btn bold'
              shape='round'
              icon={deviceType !== "iPhone" && deviceType !== "iPad" && deviceType !== "Macintosh"? <AndroidFilled/> : <AppleFilled/>}
            >
              {t.appDownload}
            </Button>
          </a>
        </Layout>
    </ConfigProvider>
  );
}

export default AppLayout;